<button class="notifications-btn" (click)="openNotificationCenter()">
  <mat-icon class="ic-svg-9" aria-hidden="false" aria-label="notifications_none">notifications_none</mat-icon>
  <div class="badge-notify" *ngIf="badgeActive"></div>
</button>
